import React, { useState } from 'react';

import { RichText } from '../../rich-text/rich-text';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { useGetLibraryConstantsDictionaryData } from '@/providers/ConfigProvider';

interface ITenantDescriptionProps {
  description: any;
  node_locale: string;
  onBookingClick?: () => void;
}

const MAX_DESCRIPTION_LENGTH = 200;

const TenantDescription = ({
  description,
  node_locale,
  onBookingClick,
}: ITenantDescriptionProps) => {
  const dictionary = useGetLibraryConstantsDictionaryData();

  const [isExpanded, setIsExpanded] = useState(false);

  const plainTextDescription = description?.json
    ? documentToPlainTextString(description.json)
    : '';

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      {plainTextDescription?.length > MAX_DESCRIPTION_LENGTH ? (
        <>
          {isExpanded ? (
            <>
              <RichText
                richText={description}
                onBookingClick={onBookingClick}
              />
              <button
                className="block text-headings text-text-default underline"
                onClick={toggleExpansion}
              >
                {dictionary?.readLess}
              </button>
            </>
          ) : (
            <>
              <RichText
                richText={description}
                characterLimitCount={MAX_DESCRIPTION_LENGTH}
                onBookingClick={onBookingClick}
              />
              <button
                className="block text-headings text-text-default underline mt-4"
                onClick={toggleExpansion}
              >
                {dictionary?.readMore}
              </button>
            </>
          )}
        </>
      ) : (
        <RichText richText={description} onBookingClick={onBookingClick} />
      )}
    </>
  );
};

export default TenantDescription;
